// extracted by mini-css-extract-plugin
module.exports = {"avatarcontainer":"PcCXAE8Pog9TTrRjw-E1Mw==","avatarImage":"ZMRf6YbfkC7BFdmjs3T1hg=="};